import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ThemesRoutingModule } from './themes-routing.module';
import { ThemesComponent } from './themes.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [ThemesComponent],
  imports: [
    CommonModule,
    ThemesRoutingModule,
    SharedModule,
  ],
  exports: [ThemesComponent],

})
export class ThemesModule { }
